import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { typeOptions } from '../../../utils/type/dynamic-rendering.interfaces';
import { setValueOptions } from '../../../store/actions/setting';
import { getValueOption, valueOption } from '../../../store/selectors/selectors';
//@ts-ignore
import s from './PorchSidesColor.module.scss'


type porchColor = {
    colors: string
    id: string
    name: string
}

type PorchSidesColorT = {
    children: any
    id: string
    typeOptions: typeOptions
    values: porchColor[]
    [key: string]: unknown;
}

export const PorchSidesColor = ({ ...props }: PorchSidesColorT) => {

    const { values, id, } = props;
    const dispatch = useDispatch();

    let { selectValue, isError }: valueOption = useSelector(state => getValueOption({idOptions: id})(state));

    const onChange = (value: porchColor) => {
        dispatch(setValueOptions({ idParams: id, valueParam: value['id'] }))
    }
    return (
        <div className={s.wrap_color}>
            {values.map((value: porchColor) => {

                let isActive = selectValue === value['id']

                let classItem = `${s.color_box}`
                if (isActive) classItem += ` ${s.active}`

                return (<>
                    <div className={classItem} onClick={() => onChange(value)}>
                        <div className={s.color_item}> </div>
                        <div className={s.name}>{value['name']}</div>
                    </div>
                </>
                )
            })}

        </div>
    )
}
